import React from 'react';
export function HowItWorks() {
  const steps = [{
    title: 'Share your group basics',
    description: 'Tell us about your group size, interests, and travel timeframe'
  }, {
    title: 'Get 2-3 trip recommendations',
    description: "We'll send curated options with pricing and inclusions"
  }, {
    title: 'Choose dates + reserve space',
    description: 'Select your preferred itinerary and lock in your departure'
  }, {
    title: 'Invite travelers + collect deposits',
    description: 'We provide materials to help you promote and manage sign-ups'
  }, {
    title: 'Travel with support throughout',
    description: 'Enjoy your trip with dedicated tour management'
  }];
  return <section className="py-20 bg-neutral-50 border-y border-gray-200" data-id="element-167">
      <div className="container mx-auto px-4" data-id="element-168">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-primary text-center mb-16" data-id="element-169">
          How it works
        </h2>

        <div className="relative" data-id="element-170">
          {/* Connecting Line (Desktop) */}
          <div className="hidden lg:block absolute top-8 left-0 right-0 h-0.5 bg-gray-200 z-0" data-id="element-171"></div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-4 relative z-10" data-id="element-172">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-173">
                <div className="w-16 h-16 rounded-full bg-white border-2 border-gold text-gold flex items-center justify-center text-2xl font-bold font-serif shadow-sm mb-6 group-hover:bg-gold group-hover:text-white transition-colors duration-300" data-id="element-174">
                  {index + 1}
                </div>
                <h3 className="text-lg font-bold text-primary mb-2 px-2" data-id="element-175">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 px-2" data-id="element-176">{step.description}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}